import { createAction, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PendingInvitation } from "../../api/pendingInvitations";
import { InvitationsState } from "./types";

export const initialState: InvitationsState = {
  pending: [],
  loading: false,
  loadError: null,
  acceptingToken: null,
};

const invitationsSlice = createSlice({
  name: "invitations",
  initialState,
  reducers: {
    setInvitationsLoading: (state) => {
      state.loading = true;
      state.loadError = null;
    },
    fetchPendingInvitationsSuccess: (state, action: PayloadAction<PendingInvitation[]>) => {
      state.loading = false;
      state.pending = action.payload;
    },
    fetchPendingInvitationsFailure: (state, action: PayloadAction<string | undefined>) => {
      state.loading = false;
      state.loadError = action.payload ?? null;
    },
    setAcceptingToken: (state, action: PayloadAction<string | null>) => {
      state.acceptingToken = action.payload;
    },
  },
});

// === Saga trigger actions ===
export const fetchPendingInvitations = createAction("invitations/fetchPendingInvitations");
export const acceptPendingInvitation = createAction<string>("invitations/acceptPendingInvitation");

// === Slice actions ===
export const {
  setInvitationsLoading,
  fetchPendingInvitationsSuccess,
  fetchPendingInvitationsFailure,
  setAcceptingToken,
} = invitationsSlice.actions;

export default invitationsSlice.reducer;
